import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "../ui/input";
import { http } from "../../lib/auth";
import { CATEGORIES } from "../../data/services";
import { resetBookingLinks } from "../../lib/useBookingLinks";

const Steps = () => (
  <div className="bg-white p-8 text-sm font-light leading-relaxed text-neutral-700" data-testid="booking-links-help">
    <p className="font-display text-2xl text-neutral-950">Connect each Book button to its exact Vagaro service</p>
    <ol className="mt-4 list-decimal space-y-1 pl-5">
      <li>In Vagaro, open Settings, then Service/Class Menu (Pro app: Settings, then Services).</li>
      <li>Open a service and tap Share Link (or Booking Link), then copy it.</li>
      <li>Paste it next to the same service below and tap Save Links. Empty boxes keep opening your main booking page.</li>
    </ol>
  </div>
);

export const BookingLinksTab = () => {
  const [links, setLinks] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    http.get("/booking-links").then(({ data }) => setLinks(data || {})).catch(() => setLinks({}));
  }, []);
  const save = async () => {
    setSaving(true);
    try {
      const all = Object.fromEntries(CATEGORIES.flatMap((c) => c.services.map((s) => [s.name, links[s.name] || ""])));
      const { data } = await http.put("/admin/booking-links", { links: all });
      setLinks(data);
      resetBookingLinks();
      toast.success("Booking links saved");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Couldn't save links.");
    } finally {
      setSaving(false);
    }
  };
  if (!links) return <p className="kicker p-10">Loading…</p>;
  return (
    <div className="space-y-6" data-testid="booking-links-tab">
      <Steps />
      {CATEGORIES.map((c) => (
        <div key={c.id} className="bg-white p-8">
          <p className="kicker">{c.name}</p>
          <div className="mt-4 space-y-3">
            {c.services.map((s) => (
              <label key={s.name} className="grid items-center gap-2 md:grid-cols-[1fr_1.4fr]">
                <span className="text-sm text-neutral-800">{s.name}</span>
                <Input type="url" placeholder="https://www.vagaro.com/..." value={links[s.name] || ""}
                  onChange={(e) => setLinks((l) => ({ ...l, [s.name]: e.target.value }))} className="rounded-none"
                  data-testid={`booking-link-${s.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} />
              </label>
            ))}
          </div>
        </div>
      ))}
      <button onClick={save} disabled={saving} className="btn-ink sticky bottom-4 disabled:opacity-60" data-testid="booking-links-save-btn">{saving ? "Saving…" : "Save Links"}</button>
    </div>
  );
};
